import { CanAccess } from '@modules/common/components/CanAccess';
import { IntegrationsActionType } from '@modules/integrationsV2/store/integrationsActionType';
import { useIntegrationsStore } from '@modules/integrationsV2/store/integrationsStore';
import { trackIntegrationEvent } from '@modules/integrationsV2/utils';
import { AddRounded } from '@mui/icons-material';
import { Button } from '@mui/material';
import { PermissionOperation, PermissionResource } from 'generated/graphql';
import { AddNewIntegrationDrawer } from '../AddNewIntegrationDrawer';

export const AddNewIntegrationButton = () => {
  const dispatch = useIntegrationsStore(({ dispatch }) => dispatch);

  const onOpenAddIntegrationDrawer = () => {
    dispatch({
      type: IntegrationsActionType.SET_VIEW,
      payload: {
        isAddDrawerOpen: true,
      },
    });
    trackIntegrationEvent({ eventName: 'Add New Integration Sidebar Opened' });
  };

  return (
    <>
      <CanAccess
        resource={PermissionResource.Integration}
        operation={PermissionOperation.Write}
      >
        <Button
          variant="contained"
          size="large"
          startIcon={<AddRounded />}
          onClick={onOpenAddIntegrationDrawer}
          sx={{ zIndex: 1 }}
        >
          New Integration
        </Button>
      </CanAccess>
      <AddNewIntegrationDrawer />
    </>
  );
};
